// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=JetBrains+Mono:ital,wght@0,100..800;1,100..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Gs53E{font-family:"Inter",sans-serif;border:2px solid rgba(0,0,0,0);border-radius:.9375rem;background-color:#0078d4;color:#fff;font-size:15px;font-weight:600;padding:13px 25px;cursor:pointer;text-transform:none;min-width:220px}
.T2S0k{font-family:"Inter",sans-serif}
.zOYOR{background-color:#fff;border-radius:16px 16px 0 0;font-family:"Inter",sans-serif;top:-8px;position:relative;padding-top:48px;padding-bottom:24px;-webkit-box-shadow:0 -4px 20px -4px rgba(0,0,0,.04);box-shadow:0 -4px 20px -4px rgba(0,0,0,.04)}
.mZwQs{font-weight:700;font-size:28px;color:#0f172a;letter-spacing:-0.5px;line-height:1.3;margin-bottom:0}
.SNjOW{margin-top:12px;font-weight:400;font-size:16px;color:#64748b;letter-spacing:-0.1px;line-height:1.6;margin-left:auto;margin-right:auto}
.hhJlo{padding-top:32px !important;padding-bottom:16px !important}
.cD4Qh .XEMRA{background-color:#fff;border:1px solid #e2e8f0;border-radius:10px;padding:14px 16px;padding:.875rem 1rem;margin-bottom:10px;margin-bottom:.625rem;-webkit-transition:border-color .2s;-o-transition:border-color .2s;transition:border-color .2s}
.cD4Qh .XEMRA .MuiCheckbox-root.Mui-checked{color:#0078d4}
.cD4Qh .XEMRA:hover{border-color:#0078d4}
.cD4Qh .h30qK{font-size:18px;font-weight:600;color:#0f172a;margin:0}
.cD4Qh .XOnVa .hA_8E{color:#334155;margin:0;font-size:15px;font-weight:500}
._1CQl4{display:-webkit-box;display:-ms-flexbox;display:flex;gap:8px;gap:.5rem;-ms-flex-wrap:wrap;flex-wrap:wrap}
._1CQl4 .T8KLs{width:50px;height:50px;-o-object-fit:contain;object-fit:contain;border:1px solid #cbd5e1;border-radius:6px;padding:4px;background:#fff}
.gfjeG{display:-webkit-box;display:-ms-flexbox;display:flex}
.gfjeG .K0EJH{width:36px;height:36px;border-radius:50%;border:2px solid #fff;cursor:pointer;position:relative}
.gfjeG .K0EJH:not(:first-child){margin-left:-12px}
.gfjeG .K0EJH:nth-child(1){z-index:4}
.gfjeG .K0EJH:nth-child(2){z-index:3}
.gfjeG .K0EJH:nth-child(3){z-index:2}
.gfjeG .K0EJH:nth-child(4){z-index:1}
.doWnw{display:-webkit-box;display:-ms-flexbox;display:flex;gap:8px;gap:.5rem;-webkit-box-align:center;-ms-flex-align:center;align-items:center}
.doWnw .UQPRN{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:28px;height:28px;border-radius:50%;cursor:pointer;-webkit-transition:all .2s ease;-o-transition:all .2s ease;transition:all .2s ease}
.doWnw .UQPRN:hover{-webkit-transform:scale(1.1);-ms-transform:scale(1.1);transform:scale(1.1)}
.doWnw .UQPRN svg{font-size:24px;color:#64748b !important}
.CZ9TF{font-size:20px !important;font-weight:700 !important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonBlue": `Gs53E`,
	"baseContainer": `T2S0k`,
	"formContainer": `zOYOR`,
	"title": `mZwQs`,
	"subtitle": `SNjOW`,
	"brandAssetsContainer": `hhJlo`,
	"sectionsContainer": `cD4Qh`,
	"sectionItem": `XEMRA`,
	"sectionTitle": `h30qK`,
	"preview": `XOnVa`,
	"previewText": `hA_8E`,
	"logoPreview": `_1CQl4`,
	"logoImage": `T8KLs`,
	"colorPreview": `gfjeG`,
	"colorSwatch": `K0EJH`,
	"linksPreview": `doWnw`,
	"linkIcon": `UQPRN`,
	"brandNameText": `CZ9TF`
};
module.exports = ___CSS_LOADER_EXPORT___;
